import _classCallCheck from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
/**
 * DevExtreme (esm/renovation/ui/button.j.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import registerComponent from "../../core/component_registrator";
import BaseComponent from "../component_wrapper/button";
import { Button as ButtonComponent, defaultOptions } from "./button";
var Button = /*#__PURE__*/function (_BaseComponent) {
  _inherits(Button, _BaseComponent);
  function Button() {
    _classCallCheck(this, Button);
    return _possibleConstructorReturn(this, _getPrototypeOf(Button).apply(this, arguments));
  }
  _createClass(Button, [{
    key: "getProps",
    value: function getProps() {
      var props = _get(_getPrototypeOf(Button.prototype), "getProps", this).call(this);
      props.onKeyDown = this._wrapKeyDownHandler(props.onKeyDown);
      return props;
    }
  }, {
    key: "focus",
    value: function focus() {
      var _this$viewRef4;
      var _this$viewRef;
      return null === (_this$viewRef = this.viewRef) || void 0 === _this$viewRef ? void 0 : (_this$viewRef4 = _this$viewRef).focus.apply(_this$viewRef4, arguments);
    }
  }, {
    key: "activate",
    value: function activate() {
      var _this$viewRef5;
      var _this$viewRef2;
      return null === (_this$viewRef2 = this.viewRef) || void 0 === _this$viewRef2 ? void 0 : (_this$viewRef5 = _this$viewRef2).activate.apply(_this$viewRef5, arguments);
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      var _this$viewRef6;
      var _this$viewRef3;
      return null === (_this$viewRef3 = this.viewRef) || void 0 === _this$viewRef3 ? void 0 : (_this$viewRef6 = _this$viewRef3).deactivate.apply(_this$viewRef6, arguments);
    }
  }, {
    key: "_getActionConfigs",
    value: function _getActionConfigs() {
      return {
        onClick: {
          excludeValidators: ["readOnly"]
        },
        onSubmit: {}
      };
    }
  }, {
    key: "_propsInfo",
    get: function get() {
      return {
        twoWay: [],
        allowNull: [],
        elements: ["onSubmit"],
        templates: ["template", "iconTemplate"],
        props: ["activeStateEnabled", "hoverStateEnabled", "icon", "iconPosition", "onClick", "onSubmit", "pressed", "stylingMode", "template", "iconTemplate", "text", "type", "useInkRipple", "useSubmitBehavior", "templateData", "className", "accessKey", "disabled", "focusStateEnabled", "height", "hint", "onKeyDown", "rtlEnabled", "tabIndex", "visible", "width"]
      };
    }
  }, {
    key: "_viewComponent",
    get: function get() {
      return ButtonComponent;
    }
  }]);
  return Button;
}(BaseComponent);
export { Button as default };
registerComponent("dxButton", Button);
Button.defaultOptions = defaultOptions;